import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Box,
  Spinner,
  Flex
} from '@chakra-ui/react'
import { FC } from 'react'

import type { IHistoricoControleFornecedor } from '@base/@types/providers/Dashboard/PurchaseScheduleProvider'

import { formatDateBR } from './utils'

export type { IHistoricoControleFornecedor }

// Histórico de alterações do parâmetro Cronograma de Compras da(s) empresa(s)
const HistoricoTable: FC<{
  data: IHistoricoControleFornecedor[]
  loading: boolean
}> = ({ data, loading }) => {
  if (loading) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner />
      </Flex>
    )
  }
  return (
    <Box overflowX="auto">
      <Text fontSize="sm" color="gray.500" mb={2}>
        Alterações realizadas no parâmetro Cronograma de Compras
      </Text>
      <Table size="sm" variant="simple">
        <Thead bg="gray.100">
          <Tr>
            <Th>Data da ação</Th>
            <Th>Empresa</Th>
            <Th>Ação</Th>
            <Th>Usuário</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item, index) => (
            <Tr
              key={item.id ?? `${item.empresaId}-${item.dataAcao}-${index}`}
              _hover={{ bg: 'gray.50' }}
            >
              <Td fontSize="sm" whiteSpace="nowrap">
                {formatDateBR(item.dataAcao, 'dd/MM/yyyy HH:mm:ss')}
              </Td>
              <Td fontSize="sm">{item.empresaId ?? '-'}</Td>
              <Td fontSize="sm">{item.acao || '-'}</Td>
              <Td fontSize="sm">{item.usuarioEmail || '-'}</Td>
            </Tr>
          ))}
          {data.length === 0 && (
            <Tr>
              <Td colSpan={4} textAlign="center" color="gray.400">
                Nenhum histórico encontrado
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
  )
}

export default HistoricoTable
